import React, { useEffect, useState } from "react";

function LiveHero({ liveMatch, liveScore, liveCount, onViewAll, heroLoading }) {
    const [time, setTime] = useState("");

    useEffect(() => {
        const updateClock = () => {
            const now = new Date();
            setTime(now.toTimeString().slice(0, 8));
        };
        updateClock();
        const interval = setInterval(updateClock, 1000);
        return () => clearInterval(interval);
    }, []);

    const getTeamName = (index) => {
        if (!liveMatch) return "TBD";
        if (index === 0) return liveMatch.team1Name || "TBD";
        return liveMatch.team2Name || "TBD";
    };

    const getTeamLogo = (index) => {
        if (!liveMatch) return null;
        if (index === 0) return liveMatch.team1PicURL || null;
        return liveMatch.team2PicURL || null;
    };

    const innings2 = liveScore?.inning === 2 ? liveScore : null;
    const inningsLabel = innings2 ? "2ND INNINGS" : "1ST INNINGS";

    const team1Score = liveScore?.inning === 2
        ? (liveScore?.inning1Score !== null && liveScore?.inning1Score !== undefined
            ? liveScore.inning1Score : "0")
        : (liveScore ? liveScore.score ?? 0 : "0");
    const team1Wickets = liveScore?.inning === 2
        ? (liveScore?.inning1Wickets !== null && liveScore?.inning1Wickets !== undefined
            ? liveScore.inning1Wickets : "0")
        : (liveScore ? liveScore.wicketCount ?? 0 : "0");
    const team1Overs = liveScore?.inning === 2 ? "" : (liveScore ? `${liveScore.over} OVERS` : "0 OVERS");
    const team2Score = liveScore?.inning === 2 ? liveScore.score ?? 0 : null;
    const team2Wickets = liveScore?.inning === 2 ? liveScore.wicketCount ?? 0 : null;
    const team2Overs = liveScore?.inning === 2 ? `${liveScore.over} OVERS` : null;

    if (!liveMatch) {
        return (
            <div className="hero hero-no-match" id="live-hero">
                <div className="hero-stadium"></div>
                <div className="hero-inner">
                    <div className="hero-empty-msg">
                        {heroLoading ? "Loading..." : "No live match right now"}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="hero" id="live-hero">
            <div className="hero-stadium"></div>
            <div className="hero-inner">
                <div className="hero-top-row">
                    <div className="match-badge-row">
                        <div className="live-badge">
                            <span className="ping-dot ping-dot-pink"></span>LIVE
                        </div>
                        <div className="over-badge">{liveMatch.overs} OVER FORMAT</div>
                        <div className="match-id-badge">VIRTUAL IPL · MATCH #{liveMatch.matchId}</div>
                    </div>
                    <div className="hero-clock">{time}</div>
                </div>

                <div className="scoreboard">
                    <div className="team-side">
                        <div className="team-logo batting">
                            {getTeamLogo(0) ? (
                                <img src={getTeamLogo(0)} alt={getTeamName(0)}
                                     onError={(e) => { e.target.style.display = 'none'; }} />
                            ) : "🏏"}
                        </div>
                        <div className="team-name">{getTeamName(0)}</div>
                        <div className="team-name-sub">(e)</div>
                        <div className="team-score-big">
                            {team1Score}
                            <span className="wkts">/{team1Wickets}</span>
                        </div>
                        <div className="team-overs-txt">{team1Overs}</div>
                    </div>

                    <div className="vs-center">
                        <span className="vs-txt">VS</span>
                        <span className="inn-label">{inningsLabel}</span>
                        <div className="sim-indicator">
                            <div className="sim-dot"></div>AI MATCH
                        </div>
                    </div>

                    <div className="team-side right">
                        <div className="team-logo">
                            {getTeamLogo(1) ? (
                                <img src={getTeamLogo(1)} alt={getTeamName(1)}
                                     onError={(e) => { e.target.style.display = 'none'; }} />
                            ) : "🏏"}
                        </div>
                        <div className="team-name">{getTeamName(1)}</div>
                        <div className="team-name-sub">(e)</div>
                        {innings2 ? (
                            <>
                                <div className="team-score-big">
                                    {team2Score}
                                    <span className="wkts">/{team2Wickets}</span>
                                </div>
                                <div className="team-overs-txt">{team2Overs}</div>
                            </>
                        ) : (
                            <>
                                <div className="team-score-big tbd">— —</div>
                                <div className="team-overs-txt">YET TO BAT</div>
                            </>
                        )}
                    </div>
                </div>

                <div className="ball-rows-wrap">
                    <div className="ball-row-half">
                        {liveScore?.inning1Balls?.length > 0 && (
                            <div className="ball-row">
                                {liveScore.inning1Balls.slice(-6).map((ball, i) => {
                                    const outcome = ball.actionOutCome;
                                    let cls = "ball"; let label = "·";
                                    if (outcome === "FOUR_RUNS") { cls += " four"; label = "4"; }
                                    else if (outcome === "SIX_RUNS") { cls += " six"; label = "6"; }
                                    else if (outcome === "OUT") { cls += " wicket"; label = "W"; }
                                    else if (outcome === "NO_RUNS") { cls += " dot"; label = "·"; }
                                    else if (outcome === "WIDE") { cls += " dot"; label = "Wd"; }
                                    else if (outcome === "ONE_RUN") { cls += " run1"; label = "1"; }
                                    else if (outcome === "TWO_RUNS") { cls += " run2"; label = "2"; }
                                    else if (outcome === "THREE_RUNS") { cls += " run1"; label = "3"; }
                                    else { cls += " run1"; label = "?"; }
                                    return <div key={i} className={cls}>{label}</div>;
                                })}
                            </div>
                        )}
                    </div>
                    <div className="ball-row-half">
                        {liveScore?.inning2Balls?.length > 0 && (
                            <div className="ball-row">
                                {liveScore.inning2Balls.slice(-6).map((ball, i) => {
                                    const outcome = ball.actionOutCome;
                                    let cls = "ball"; let label = "·";
                                    if (outcome === "FOUR_RUNS") { cls += " four"; label = "4"; }
                                    else if (outcome === "SIX_RUNS") { cls += " six"; label = "6"; }
                                    else if (outcome === "OUT") { cls += " wicket"; label = "W"; }
                                    else if (outcome === "NO_RUNS") { cls += " dot"; label = "·"; }
                                    else if (outcome === "WIDE") { cls += " dot"; label = "Wd"; }
                                    else if (outcome === "ONE_RUN") { cls += " run1"; label = "1"; }
                                    else if (outcome === "TWO_RUNS") { cls += " run2"; label = "2"; }
                                    else if (outcome === "THREE_RUNS") { cls += " run1"; label = "3"; }
                                    else { cls += " run1"; label = "?"; }
                                    return <div key={i} className={cls}>{label}</div>;
                                })}
                            </div>
                        )}
                    </div>
                </div>

                <div className="match-players">
                    <div className="mp-card">
                        <div className="mp-role">Batter (e)</div>
                        <div className="mp-name">{liveScore?.batsmanName || "—"}</div>
                        <div className="mp-stats">
                            <span className="mp-stat-hi">
                                {liveScore?.batsmanRuns !== undefined ?
                                    `${liveScore.batsmanRuns}* (${liveScore.batsmanBalls})` : "—"}
                            </span>
                        </div>
                    </div>
                    <div className="mp-card">
                        <div className="mp-role">Bowler (e)</div>
                        <div className="mp-name">{liveScore?.bowlerName || "—"}</div>
                        <div className="mp-stats">
                            <span className="mp-stat-hi">
                                {liveScore?.bowlerWickets !== undefined ?
                                    `${liveScore.bowlerWickets}/${liveScore.bowlerRuns}` : "—"}
                            </span>
                        </div>
                    </div>
                </div>

                {liveCount > 1 && (
                    <div className="view-all-banner" onClick={() => onViewAll && onViewAll()}>
                        <span className="ping-dot ping-dot-banner"></span>
                        {liveCount} LIVE MATCHES NOW · TAP TO VIEW ALL ↓
                    </div>
                )}
            </div>
        </div>
    );
}

export default LiveHero;
//fdew